import axios from "axios";
import { headersProvider, masterApiHeader } from "../apiHelpers";
import constants from "../constants";

export const usersLogin = ({ accessToken }) =>
  axios.post(
    `${constants.apiHost}/users/login`,
    {
      accessToken,
    },
    {
      headers: headersProvider(),
      noTrailingSlash: true,
    },
  );

export const usersMSLogin = ({ accessToken }) =>
  axios.post(
    `${constants.apiHost}/users/mslogin`,
    {
      accessToken,
    },
    {
      headers: headersProvider(),
      noTrailingSlash: true,
    },
  );

export const userDetails = () =>
  axios.get(`${constants.masterApi}/base-backend/auth/details`, {
    headers: headersProvider(),
  });

export const workspaceUsers = () =>
  axios.get(`${constants.masterApi}/base-backend/user/workspace-users-list/`, {
    headers: headersProvider(),
  });
export const changeUserRole = (roleId) =>
  axios.get(`${constants.masterApi}/base-backend/auth/login-as/${roleId}`, {
    headers: headersProvider(),
  });

export const getSelfNotifications = ({
  take,
  page,
  sortByOptions,
  filterOptions,
}) =>
  axios.post(
    `${constants.apiHost}/notifications/self`,
    {
      page,
      take,
      sortByOptions,
      filterOptions,
    },
    {
      headers: headersProvider(),
    },
  );

export const getDashboardTAT = ({ month }) =>
  axios.get(`${constants.apiHost}/dashboard/sla/${month}`, {
    headers: headersProvider(),
  });

export const getUnseenNotifications = () =>
  axios.get(`${constants.apiHost}/unseenCount`, {
    headers: headersProvider(),
  });

export const updateNotificationStatus = ({ id }) =>
  axios.put(
    `${constants.apiHost}/makeseen`,
    {
      id,
    },
    {
      headers: headersProvider(),
    },
  );
export const getBuList = () =>
  axios.get(`${constants.masterApi}/base-backend/business-unit/all`, {
    headers: headersProvider(),
  });
export const getBuListAll = () =>
  axios.get(`${constants.masterApi}/base-backend/business-unit/all`, {
    headers: headersProvider(),
  });
export const getUserRoleList = () =>
  axios.get(`${constants.masterApi}/base-backend/role/all`, {
    headers: headersProvider(),
  });

export const getModuleList = () =>
  axios.get(`${constants.masterApi}/base-backend/user/module-list`, {
    headers: headersProvider(),
  });
export const addBuApi = ({ buData }) =>
  axios.post(
    `${constants.masterApi}/base-backend/business-unit/create`,
    {
      ...buData,
    },
    {
      headers: headersProvider(),
    },
  );
export const updateBuApi = ({ buData }) =>
  axios.put(
    `${constants.masterApi}/base-backend/business-unit/update`,
    {
      ...buData,
    },
    {
      headers: headersProvider(),
    },
  );

export const deleteBuApi = ({ id }) =>
  axios.delete(
    `${constants.masterApi}/base-backend/business-unit/delete/${id}`,
    {
      headers: headersProvider(),
    },
  );

export const getUserFromMaster = () =>
  axios.get(`${constants.masterApi}/base-backend/user/all`, {
    headers: headersProvider(),
  });
export const addMasterUser = ({ userData }) =>
  axios.post(
    `${constants.masterApi}/base-backend/user/create`,
    {
      ...userData,
    },
    {
      headers: masterApiHeader(),
    },
  );

export const updateMasterUser = ({ userData }) =>
  axios.put(
    `${constants.masterApi}/base-backend/user/update`,
    {
      ...userData,
    },
    {
      headers: masterApiHeader(),
    },
  );

export const deleteMasterUser = ({ id }) =>
  axios.delete(`${constants.masterApi}/base-backend/user/delete/${id}`, {
    headers: masterApiHeader(),
  });

export const getBuDetails = ({ id }) =>
  axios.post(
    `${constants.masterApi}/base-backend/user/budetails`,
    {
      id,
    },
    {
      headers: masterApiHeader(),
    },
  );
export const getOrgDetailsFromMaster = () =>
  axios.get(`${constants.masterApi}/base-backend/organization/orgbyId/1`, {
    headers: masterApiHeader(),
  });
